import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  padding: 2rem;
  width: 100%;
  min-height: 100%;
  background: #ededed;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const DummyCard = styled.div`
  background: transparent;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 6px 16px rgba(0, 0, 0, 0.07),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(17, 24, 39, 0.08);
`;

const DummyCardTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const DummyCardText = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
`;

const DUMMY_CARDS = Array.from({ length: 24 }, (_, i) => ({
  title: `Dummy Section ${i + 1}`,
  text: "This is placeholder content used to test scrolling behavior on this page. Replace it with real content whenever it's ready.",
}));

function TestPage() {
  return (
    <PageContainer>
      <ContentGrid>
        {DUMMY_CARDS.map((card, i) => (
          <DummyCard key={i}>
            <DummyCardTitle>{card.title}</DummyCardTitle>
            <DummyCardText>{card.text}</DummyCardText>
          </DummyCard>
        ))}
      </ContentGrid>
    </PageContainer>
  );
}

export default TestPage;
